import {AgentSearchDto} from '../../entity/dto/agent-search-dto'
import GrantAIStore from '../store/grant-ai-store'
import {ExecuteAgentDto} from '../../entity/dto/execute-agent-dto'
import {DocumentRunnerConfig} from '../../entity/resource/scraper-config-resource'

export default class GrantAIService {
  grantAIStore: GrantAIStore;

  constructor(grantAIStore: GrantAIStore) {
    this.grantAIStore = grantAIStore;
  }

  getInitialValues = (): AgentSearchDto => {
    return {
      state: '', county: '', parcelNumber: ''
    };
  }

  executeAgent = async (organizationId: string, tmsNumber: string, batchId: string, config?: DocumentRunnerConfig): Promise<void> => {
    const executeAgentDto: ExecuteAgentDto = {
      priority: config?.priority ?? '',
      countyCode: config?.code ?? '',
      tmsNumbers: tmsNumber === '' ? [] : tmsNumber.split(',').map(item => item.trim()),
      proxy: config?.proxy ?? '',
      retryProxy: config?.retryProxy ?? '',
      batchID: batchId,
      sectionToScrape: config?.scraperSection
    };

    await this.grantAIStore.executeAgent(organizationId, executeAgentDto);
  }

  downloadArchive = async (downloadUrl: string, fileName: string): Promise<void> => {
    if (!downloadUrl || !downloadUrl.startsWith('http')) throw new Error('Invalid download URL provided');

    const response = await fetch(downloadUrl);
    if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText}`);

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = `${fileName}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
